import { render, staticRenderFns } from "./DownloadTopSuppliersReportPopUp.vue?vue&type=template&id=9befe196&scoped=true&"
import script from "./DownloadTopSuppliersReportPopUp.vue?vue&type=script&lang=js&"
export * from "./DownloadTopSuppliersReportPopUp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9befe196",
  null
  
)

export default component.exports